import {Injectable} from '@angular/core';

@Injectable()
export class BookingListMultiSelectService<Key = number, Item = any> {
  cacheMap: {[key: number]: Item} = {};
  private _selected: Key[] = [];

  get selected() {
    return this._selected;
  }

  get count() {
    return this._selected.length;
  }

  hasSelected(key: Key) {
    return this._selected.includes(key);
  }

  select(key: Key) {
    this._selected.push(key);
  }

  deselect(key: Key) {
    this._selected = this._selected.filter((item) => item !== key);
  }

  deselectAll() {
    this._selected = [];
  }

  toggle(key: Key) {
    this.hasSelected(key) ? this.deselect(key) : this.select(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-list/booking-list-multi-select.service.ts